import {
  CLASSROOM_MODULE_CREATE_SECTION,
  CLASSROOM_MODULE_GET_SECTION,
} from '../actions';
import * as classRoomSelectors from '../../selectors/classroom';
import * as userSelectors from '../../selectors/user';

const createSection =
  ({ content, parent, educatorOnly, hidden = true, onSelect }) =>
  async (dispatch, getState) => {
    const state = getState();
    const user = userSelectors.currentUserSlim(state);
    const classRoom = classRoomSelectors.currentClassRoomId(state);

    const id = `local.${Date.now()}`;

    const section = {
      id,
      title: '',
      hidden,
      updatedAt: new Date().toISOString(),
      writer: user,
      space: classRoom,
      parent,
      educatorOnly,
    };
    dispatch({
      type: CLASSROOM_MODULE_CREATE_SECTION,
      payload: {
        section,
      },
    });
    dispatch({
      type: CLASSROOM_MODULE_GET_SECTION,
      status: 'success',
      payload: {
        content,
      },
    });
    if (onSelect) {
      dispatch(onSelect(id, educatorOnly));
    }
  };

export default createSection;
